export const DISCOUNT_BASE = {
  SALE_PRICE: "PRECO_VENDA",
  CONSIGNMENT_PRICE: "PRECO_CONSIGNACAO",
  BOTH: "AMBOS",
};

export const hasSalePriceDiscount = (product) => {
  const salePrice = Number(product?.salePrice);
  const discountPrice = Number(product?.descontoPrice);

  return (
    product?.salePrice !== undefined &&
    product?.salePrice !== null &&
    product?.salePrice !== "" &&
    product?.descontoPrice !== undefined &&
    product?.descontoPrice !== null &&
    product?.descontoPrice !== "" &&
    !Number.isNaN(salePrice) &&
    salePrice > 0 &&
    !Number.isNaN(discountPrice) &&
    discountPrice > 0 &&
    discountPrice !== salePrice
  );
};

/** Preço final com acréscimo persistido no asset (quando % > 0). */
export const hasAcrescimoSalePrice = (product) => {
  const withAcrescimo = Number(
    product?.salePriceWithAcrescimo ?? product?.effectiveSalePrice
  );
  const percent = Number(product?.acrescimoPercent);

  return (
    !Number.isNaN(withAcrescimo) &&
    withAcrescimo > 0 &&
    !Number.isNaN(percent) &&
    percent > 0
  );
};

/** Exibe DE/PARA de desconto só quando não há acréscimo efetivo. */
export const shouldShowSaleDiscount = (product) =>
  hasSalePriceDiscount(product) && !hasAcrescimoSalePrice(product);

/**
 * Preço de venda efetivo no site / carrinho / checkout.
 * Prioridade alinhada ao OrderService: acréscimo > desconto PARA > PRECO_VENDA.
 */
export const getProductSalePrice = (product) => {
  if (hasAcrescimoSalePrice(product)) {
    return product.salePriceWithAcrescimo ?? product.effectiveSalePrice;
  }

  return hasSalePriceDiscount(product)
    ? product.descontoPrice
    : product?.salePrice;
};

const limparTexto = (v) =>
  (v || "").replace(/-/g, " ").replace(/\s+/g, " ").trim();

// Os dados do catálogo vêm todos em CAIXA ALTA. Em texto alternativo isso atrapalha:
// leitor de tela costuma soletrar palavra curta toda em maiúscula.
const capitalizar = (texto) =>
  texto
    .toLowerCase()
    .replace(/(^|\s)(\p{L})/gu, (_, espaco, letra) => espaco + letra.toUpperCase());

/**
 * Texto alternativo da imagem de uma peça.
 *
 * O campo `alt` do catálogo vem vazio em 100% das peças, e o componente caía num
 * fallback que acabava colocando o CAMINHO DO ARQUIVO de imagem como texto
 * alternativo. Aqui o texto é montado a partir do que já está cadastrado —
 * marca, nome e cor — sem precisar de nenhum dado novo.
 *
 * @param {number} index posição da foto; da segunda em diante entra a numeração,
 *                       senão várias fotos da mesma peça ficam com texto idêntico.
 */
export const getProductAltText = (product, index = 0) => {
  const marca = limparTexto(product?.brand);
  const nome = limparTexto(product?.name);
  const cor = limparTexto(product?.color);

  const base = [marca, nome].filter(Boolean).join(" ");
  if (!base) return "Peça do acervo Take Me Vintage";

  // Capitaliza só os dados; o conector fica em minúscula, senão sai "Na Cor Preto".
  const texto = cor
    ? `${capitalizar(base)} na cor ${capitalizar(cor)}`
    : capitalizar(base);

  return index > 0 ? `${texto} — foto ${index + 1}` : texto;
};

/**
 * A peça está disponível para aluguel?
 *
 * Usado para manter peça de aluguel fora do índice de busca: aluguel é atendido
 * como serviço, com agendamento, e não como vitrine navegável.
 */
export const isRentalProduct = (product) => {
  const preco = Number(product?.rentPrice ?? product?.preco_aluguel);
  return !Number.isNaN(preco) && preco > 0;
};
